const IconAngleRight = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="icon-angle-right"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m6.733,23.888l-.707-.707,10.827-10.827c.095-.095.146-.22.146-.354s-.052-.259-.146-.354L6.026.819l.707-.707,10.827,10.827c.283.283.439.66.439,1.061s-.156.777-.439,1.061l-10.827,10.827Z" />
    </svg>
  );
};

export default IconAngleRight;
